//Components
import { Button, Modal } from 'react-bootstrap';

//Styles
import './styles.scss';


interface ActivityModalButtons {
    text: string;
    func: Function;
    disabled?: boolean;
}

interface ActivityModalProps {
    body: any;
    buttons: Array<ActivityModalButtons>;
    header: string;
    open: boolean;
    onClose: Function;
}

const ActivityModal = (props: ActivityModalProps) => {
    const { body, buttons, header, open, onClose } = props;

    return (
        <Modal animation={false} show={open} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
            <Modal.Footer>
                {buttons.map((btn, idx) =>
                    <Button disabled={btn.disabled} key={idx} variant="secondary" onClick={(e) => btn.func(e)}>
                        {btn.text}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    )
}

export default ActivityModal;
